/* Micro-Interactions, Scroll Progress & Custom Cursor Engine */

// 1. Top Scroll Progress Indicator Bar
export function initScrollProgress() {
  const progressBar = document.getElementById('scroll-progress');
  if (!progressBar) return;

  window.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercent = docHeight > 0 ? (scrollTop / docHeight) * 100 : 0;
    progressBar.style.width = `${scrollPercent}%`;
  });
}

// 2. Interactive Custom Cursor & Particle Trail System
export function initCustomCursor() {
  // Only enable on desktop pointer devices
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  const dot = document.getElementById('cursor-dot');
  const ring = document.getElementById('cursor-ring');
  if (!dot || !ring) return;

  let mouseX = -100;
  let mouseY = -100;
  let ringX = -100;
  let ringY = -100;
  let lastParticleTime = 0;

  // Particle Symbols Pool
  const symbols = ['+', '</>', '•', '{ }', '01', 'λ'];

  window.addEventListener('mousemove', (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;

    dot.style.left = `${mouseX}px`;
    dot.style.top = `${mouseY}px`;

    // Particle Trail Generation (Throttled for ultra smooth 60fps performance)
    const now = performance.now();
    if (now - lastParticleTime > 45) { // every 45ms during movement
      createTrailParticle(mouseX, mouseY, symbols[Math.floor(Math.random() * symbols.length)]);
      lastParticleTime = now;
    }
  });

  function renderCursor() {
    ringX += (mouseX - ringX) * 0.16;
    ringY += (mouseY - ringY) * 0.16;

    ring.style.left = `${ringX}px`;
    ring.style.top = `${ringY}px`;

    requestAnimationFrame(renderCursor);
  }

  renderCursor();

  // Creative Particle Spark Creator
  function createTrailParticle(x, y, symbol) {
    const p = document.createElement('div');
    p.className = 'cursor-particle';
    p.textContent = symbol;
    p.style.left = `${x + (Math.random() * 12 - 6)}px`;
    p.style.top = `${y + (Math.random() * 12 - 6)}px`;
    p.style.fontSize = `${Math.random() * 6 + 8}px`;

    document.body.appendChild(p);

    setTimeout(() => {
      p.remove();
    }, 600);
  }

  // Click Ripple Wave Effect
  window.addEventListener('click', (e) => {
    const wave = document.createElement('div');
    wave.className = 'cursor-click-wave';
    wave.style.left = `${e.clientX}px`;
    wave.style.top = `${e.clientY}px`;
    document.body.appendChild(wave);

    setTimeout(() => {
      wave.remove();
    }, 650);
  });

  // Context-Aware Cursor Hover States (No text label overlay)
  document.addEventListener('mouseover', (e) => {
    const target = e.target;

    // 1. Skill Tags
    if (target.closest('.editorial-tag')) {
      ring.classList.add('cursor-hover-tag');
      return;
    }

    // 2. Project Cards & Case Study buttons
    if (target.closest('.project-editorial-card') || target.closest('.open-casestudy-btn')) {
      ring.classList.add('cursor-hover-project');
      return;
    }

    // 3. General Buttons & Links
    if (target.closest('a, button, input, textarea, .panel-row')) {
      ring.classList.add('cursor-hover-btn');
      return;
    }
  });

  document.addEventListener('mouseout', (e) => {
    const target = e.target;
    if (target.closest('.editorial-tag, .project-editorial-card, .open-casestudy-btn, a, button, input, textarea, .panel-row')) {
      ring.classList.remove('cursor-hover-tag', 'cursor-hover-project', 'cursor-hover-btn');
    }
  });
}

// 3. Scroll Reveal Observer
export function initScrollReveal() {
  const revealElements = document.querySelectorAll('.reveal-on-scroll');

  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -40px 0px',
    threshold: 0.1
  };

  const revealObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  revealElements.forEach(el => revealObserver.observe(el));
}
